<!-- Multi-tax display -->
<div class="row" *ngFor="let tax of taxes">
  <div class="col-auto">
    <p class="tax-of-base">
      {{ name(tax) | async }}:
    </p>
  </div>
  <div class="col text-right">
    <p class="total-tax">
      <span>{{ tax.totalTax | pepCurrency: currency:locale:2 }}</span>
    </p>
  </div>
</div>